/* eslint-disable max-len */
type TriangleRoundProps = {
  color: string
  draw?: 'stroke' | 'fill'
  className?: string
  strokeWidth?: string
}

export const TriangleRound = ({ color, draw = 'fill', className, ...rest }: TriangleRoundProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="83" 
      height="100" 
      viewBox="0 0 83 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M0 87.3163V12.8307C0 5.24814 6.0826 0 12.8912 0C15.0604 0 17.088 0.583607 19.2659 1.89348L74.1596 35.7124C79.6666 39.0671 83 42.8584 83 49.9957C83 57.133 79.6666 60.9286 74.1596 64.2876L19.2659 98.1022C17.088 99.4164 15.0604 99.9957 12.8912 99.9957C6.0783 99.9957 0 94.7519 0 87.3163Z" 
        fill={draw === 'fill' ? drawColor : ''}
        stroke={draw === 'stroke' ? drawColor : ''}
        {...rest}
      />
    </svg>

  )
}
